import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { config } from '../config';
import { api } from '../api';
import './login.css';

const msal = new PublicClientApplication({
  auth: {
    clientId: config.appId,
    authority: config.authority,
    redirectUri: config.redirectUri,
    knownAuthorities: ['login.microsoftonline.com'],
  },
  cache: { cacheLocation: 'localStorage' },
});

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const initialised = useRef(false);

  const doLogin = async (accessToken: string) => {
    try {
      const res = await api.login(accessToken);
      if (res?.token) localStorage.setItem('token', res.token);
      navigate('/', { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Error al iniciar sesión');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (process.env.NODE_ENV === 'development' || localStorage.getItem('token')) {
      navigate('/', { replace: true });
      return;
    }

    if (initialised.current) return;
    initialised.current = true;

    msal.initialize().then(() => {
      msal.handleRedirectPromise().then((result) => {
        if (result?.accessToken) {
          localStorage.setItem('accessToken', result.accessToken);
          doLogin(result.accessToken);
        } else {
          setLoading(false);
        }
      }).catch((e) => {
        setError(e?.message ?? 'Error de autenticación');
        setLoading(false);
      });
    });
  }, [navigate]);

  const handleLogin = () => {
    setError(null);
    msal.loginRedirect({ scopes: config.scopes, prompt: 'select_account' });
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">
          <span className="icon-xl icon-agenda" />
        </div>
        <div className="login-title">Consulta de clientes</div>
        {error ? <div className="login-error">{error}</div> : null}
        {loading ? (
          <div className="login-loading">Verificando…</div>
        ) : (
          <button type="button" className="login-btn" onClick={handleLogin}>
            <svg className="login-btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
              <rect x="1" y="1" width="9" height="9" fill="#f25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
              <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            Iniciar sesión con Microsoft
          </button>
        )}
      </div>
    </div>
  );
}
